/**
 * csair app login
 * @param {fucntion} error 调用登录func异常回调函数
 */
export default function appLogin(error) {
    error = error || function () { };
    try {
        switch (window.CSNativeObject.getOSType()) {
            case 'android':
                // android 需要登出再登录，解决安卓token失效后一直死循环查不出数据问题
                window.appLoginOut = function () {
                    window.appLogin = function () {
                        window.location.reload();
                    };
                    window.CSNativeObject.nativeLogin('appLogin');
                };
                window.CSNativeObject.nativeLoginOut('appLoginOut');
                break;
            case 'iPhone':
                window.appLogin = function () {
                    window.location.reload();
                };
                window.CSNativeObject.nativeLogin('appLogin');
                break;
            default:
                error();
                break;
        }
    }
    catch (e) {
        error();
    }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/app/appLogin.js
// module id = null
// module chunks = 